import React, { useEffect, useState } from "react";
import { Col, Card, CardBody, Table } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const getChartOptions = (index) => {
  var options = {
    chart: { sparkline: { enabled: !0 } },
    dataLabels: { enabled: !1 },
    colors: ["#556ee6"],
    plotOptions: {
      radialBar: {
        hollow: { margin: 0, size: "60%" },
        track: { margin: 0 },
        dataLabels: { show: !1 },
      },
    },
  };
  switch (index) {
    case 1:
      options["colors"][0] = "#556ee6";
      break;
    case 2:
      options["colors"][0] = "#34c38f";
      break;
    case 3:
      options["colors"][0] = "#f46a6a";
      break;
    default:
      break;
  }

  return options;
};

const TotalSellngProduct = ({ monthlyHotelReservation, monthlyVisa, monthlyVoyage }) => {
  const [selectedMonth, setSelectedMonth] = useState("2025-02"); // Default to the first month in the data
  const [sellingData, setSellingData] = useState([]);

  // Calculate the total price for each category for the selected month, only for paid entries
  const calculateTotals = (month) => {
    const hotelTotal = (monthlyHotelReservation[month] || [])
      .filter((reservation) => reservation.ispayed === true) // Filter for paid reservations
      .reduce((sum, reservation) => sum + parseFloat(reservation.totalPrice || 0), 0);

    const visaTotal = (monthlyVisa[month] || [])
      .filter((visa) => visa.ispayed === true) // Filter for paid visas
      .reduce((sum, visa) => sum + parseFloat(visa.totalPrice || 0), 0);

    const voyageTotal = (monthlyVoyage[month] || [])
      .filter((voyage) => voyage.ispayed === true) // Filter for paid voyages
      .reduce((sum, voyage) => sum + parseFloat(voyage.totalAmount || 0), 0);

    const total = hotelTotal + visaTotal + voyageTotal;

    return [
      {
        name: "Hotel Reservations",
        desc: "Total price for paid hotel reservations",
        value: hotelTotal,
        percentage: total > 0 ? (hotelTotal / total) * 100 : 0,
      },
      {
        name: "Visa Applications",
        desc: "Total price for paid visa applications",
        value: visaTotal,
        percentage: total > 0 ? (visaTotal / total) * 100 : 0,
      },
      {
        name: "Voyage Reservations",
        desc: "Total price for paid voyage reservations",
        value: voyageTotal,
        percentage: total > 0 ? (voyageTotal / total) * 100 : 0,
      },
    ];
  };

  useEffect(() => {
    // Set the selling data based on the selected month
    const totals = calculateTotals(selectedMonth);
    setSellingData(totals);
  }, [selectedMonth, monthlyHotelReservation, monthlyVisa, monthlyVoyage]);

  const onChangeMonth = (value) => {
    setSelectedMonth(value);
  };

  // Get unique months from the data
  const months = [
    ...new Set([
      ...Object.keys(monthlyHotelReservation),
      ...Object.keys(monthlyVisa),
      ...Object.keys(monthlyVoyage),
    ]),
  ];

  // Format numbers with commas for better readability
  const formatNumber = (num) => {
    return num.toLocaleString("en-US", { maximumFractionDigits: 2 });
  };

  return (
    <React.Fragment>
      <Col xl="4">
        <Card>
          <CardBody>
            <div className="clearfix">
              <div className="float-end">
                <div className="input-group input-group-sm">
                  <select
                    className="form-select form-select-sm"
                    value={selectedMonth}
                    onChange={(e) => {
                      onChangeMonth(e.target.value);
                    }}
                  >
                    {months.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                  <label className="input-group-text">Month</label>
                </div>
              </div>
              <h4 className="card-title mb-4">Monthly Totals (Paid)</h4>
            </div>

            <div className="text-muted text-center">
              <p className="mb-2">Selected Month: {selectedMonth}</p>
              <h4>{formatNumber(sellingData.reduce((sum, data) => sum + data.value, 0))} dzd</h4>
              <p className="mt-4 mb-0">
                <span className="badge badge-soft-success font-size-11 me-2">
                  {" "}
                  0.6% <i className="mdi mdi-arrow-up" />{" "}
                </span>{" "}
                From previous period
              </p>
            </div>

            <div className="table-responsive mt-4">
              <Table className="table align-middle mb-0">
                <tbody>
                  {(sellingData || []).map((data, key) => {
                    const options = getChartOptions(key + 1);
                    return (
                      <tr key={key}>
                        <td>
                          <h5 className="font-size-14 mb-1">{data.name}</h5>
                          <p className="text-muted mb-0">{data.desc}</p>
                        </td>

                        <td>
                          <div id="radialchart-1">
                            <ReactApexChart
                              options={{
                                ...options,
                                plotOptions: {
                                  radialBar: {
                                    hollow: { margin: 0, size: "60%" },
                                    track: { margin: 0 },
                                    dataLabels: {
                                      show: true,
                                      name: { show: false },
                                      value: {
                                        show: true,
                                        fontSize: "16px",
                                        formatter: function (val) {
                                          return ``; // Display percentage with one decimal place
                                        },
                                      },
                                    },
                                  },
                                },
                              }}
                              series={[data.percentage]} // Use percentage for the radial bar
                              type="radialBar"
                              height={60}
                              width={60}
                              className="apex-charts"
                            />
                          </div>
                        </td>
                        <td>
                          <p className="text-muted mb-1">Total</p>
                          <h5 className="mb-0">{formatNumber(data.value)} dzd</h5>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default TotalSellngProduct;